import React from 'react';

import { Grid, RadioGroup } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { RadioGroupItem } from './RadioGroupItem/RadioGroupItem';

import { FormControlLabel, Radio } from './style';

export function RadioGroupComponent({
  items,
  groupValue,
  setGroupValue,
  formControlClassName,
  Label
}) {
  const handleDefaultChange = ({ target: { value } }) => {
    setGroupValue(value);
  };

  const getClassName = value => (value === groupValue ? 'selected' : '');

  const renderLabel = item => <Label item={item} />;

  return (
    <RadioGroup value={groupValue} onChange={handleDefaultChange}>
      <Grid container spacing={2}>
        {items.map(item => (
          <Grid item sm={6} key={item.value}>
            <FormControlLabel
              value={item.value}
              control={<Radio color="primary" size="small" />}
              label={renderLabel(item)}
              className={classnames(getClassName(item.value), formControlClassName)}
            />
          </Grid>
        ))}
      </Grid>
    </RadioGroup>
  );
}

RadioGroupComponent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  groupValue: PropTypes.string.isRequired,
  setGroupValue: PropTypes.func.isRequired,
  formControlClassName: PropTypes.string,
  Label: PropTypes.func,
};

RadioGroupComponent.defaultProps = {
  items: [],
  formControlClassName: "default",
  Label: RadioGroupItem,
};
